const context = require.context('./', true, /.+\/index\.js$/)

const plugins = {}

context.keys().forEach(key => {
  
  const plugin = context(key).default
  if (!plugin || !plugin.name) return
  plugins[plugin.name] = plugin
})

export default plugins